// extracted by mini-css-extract-plugin
export default {"container":"CountryCard_container__qoYCP","card":"CountryCard_card__Q589V","country_img":"CountryCard_country_img__6u57a","country_info":"CountryCard_country_info__P9B2R"};